module.exports = __webpack_public_path__ + "static/media/Results-2.054f7215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proof/Results-2.jpg
// module id = 365
// module chunks = 0